import { notification } from "antd";

const openStyledNotification = ({
  type = "success",
  message = "",
  className = "",
  description = "",
  resultObject = {},
  noti = false
}) => {
  let codeFromObj = null;
  let descFromObj = null;

  switch (type) {
    case "success":
      if (resultObject.data?.status) {
        codeFromObj = `Success`;
        descFromObj =
          resultObject?.data?.status?.details?.reduce(
            (accumulator, currentValue) =>
              `${accumulator}${currentValue.value}\n`,
            ""
          ) || resultObject?.data?.status?.description;
      }
      notification.success({
        message: message || codeFromObj || "Success",
        description: description || descFromObj,
        className: className,
        style: {
          backgroundColor: "#f6ffed",
          borderRadius: "8px",
          padding: "10px",
          border: "0.5px solid ",
          borderColor: "#52c41a",
        },
        closeIcon: "✖",
      });
      break;
    case "error":
      if (resultObject?.code) {
        codeFromObj = `Error (${resultObject.code})`;
        descFromObj = resultObject.message;
      } else if (resultObject.data?.status) {
        codeFromObj = `Error (${resultObject.data?.status?.code})`;
        descFromObj =
          resultObject?.data?.status?.details?.reduce(
            (accumulator, currentValue) =>
              `${accumulator}${currentValue.value}\n`,
            ""
          ) || resultObject?.data?.status?.description;
      }

      if (noti) {
        notification.error({
          message: codeFromObj || message || "Error! Please Try Again",
          description: descFromObj || description || message,
          className: className,
          style: {
            backgroundColor: "#fff2f0",
            borderRadius: "8px",
            padding: "10px",
            border: "0.5px solid ",
            borderColor: "#ff4d4f",
          },
          closeIcon: "✖",
        });
      }

      break;
    default:
      // If type is not recognized, you can handle it here or do nothing
      break;
  }
};

export default openStyledNotification;
